import wixLocation from 'wix-location';

export async function getMetasiteId() {
    return await fetch(wixLocation.baseUrl, {"method": "GET"})
    .then(res => res.text())
    .then(text => {
        const metaSiteId = text.split(`{"data":{"site":{"metaSiteId":"`)[1].split('"')[0];
        return metaSiteId
    })
    .catch(err => console.log(err));
}